/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { formatCheck2Frontend } from "../../../../actions/Checks/util";
import { CHECK_LOCATION, Check } from "../../../../actions/Layers/constants";
import { useLayerChecks } from "../../../../hooks/useLayerChecks";
import { callAvosApi } from "../../../../utils/useAvosApiHook";
import useNavigateFrom from "../../../../utils/useNavigateFrom";
import { Loading } from "../../../Helper/Loading";
import { BoxItem } from "../../AddItem/components/Summary/Boxes";
import { LayerLabResults } from "./LayerCustomCheckResults";

import { useRouteLayer, useRouteLayerQuery } from "../../../../hooks/useCurrentEntities";

export default function LabCheck({ title }: { title: string }) {
    const layer = useRouteLayer();
    const { data: checks = [], isLoading: checksLoading } = useLayerChecks(layer?.tenant_id, layer?.id ?? undefined);
    const isLoading = useRouteLayerQuery().isLoading;
    const [localCheck, setCheck] = useState<Check | null>(null);
    const labChecks = checks.filter((i) => i.location === CHECK_LOCATION.LAB_CHECK).sort((a, b) => b.check_id - a.check_id);
    const { getNextRoute } = useNavigateFrom();

    const LatestLabCheckId = labChecks[0];

    useEffect(() => {
        if (LatestLabCheckId && !checksLoading) {
            callAvosApi(`/checks/${LatestLabCheckId.check_id}/`).then((response) => {
                setCheck(formatCheck2Frontend(response.data));
            });
        }
    }, [LatestLabCheckId, checksLoading]);

    if (isLoading) {
        return <Loading />;
    }

    if (!layer || !checks || !LatestLabCheckId) {
        return null;
    }

    return (
        <div>
            <div className="d-flex">
                <h3 className=" mb-0">{title}</h3>

                <div className="ms-auto">
                    {localCheck && (
                        <Button color="secondary"
                            title={title}
                            outline size="xs"
                            href={getNextRoute(`/layer/${localCheck?.layer_id || layer.id}/add-check/${LatestLabCheckId?.check_id}/summary`)}
                        >
                            View Check
                        </Button>
                    )}
                </div>
            </div>

            {/* TODO REPEATED LOGIC */}
            <div className="pt-3">
                {!localCheck && <div className="text-warning">No {title} available</div>}
                {localCheck?.avocados && <BoxItem avocados={localCheck.avocados} check={localCheck} layer={layer} title={`Check ${localCheck.check_id}`} />}
            </div>
            <LayerLabResults />
        </div>
    );
}
